import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, of } from 'rxjs';

export interface DocEntry {
    id: string;
    title: string;
    file: string;
    description?: string;
}

const DOCS_INDEX = 'assets/docs/index.json';
const DOCS_BASE = 'assets/docs/';

@Injectable({
    providedIn: 'root',
})
export class DocsService {
    private http = inject(HttpClient);

    /**
     * Obtiene el índice de documentos (lista de títulos, archivos, etc.)
     */
    getIndex(): Observable<DocEntry[]> {
        return this.http.get<DocEntry[]>(DOCS_INDEX).pipe(
            catchError(() => of([]))
        );
    }

    /**
     * Retorna la URL del archivo Markdown para cargar en ngx-markdown [src].
     * Los assets se sirven desde /assets en build y en ng serve.
     */
    getMarkdownUrl(file: string): string {
        return `${DOCS_BASE}${file}`;
    }
}
